export default {
  submit: 'Submit',
  'submit.ok': 'Submitted',
  'submit.error': 'Submit Failed',
  'confirm.ok': 'Yes',
  'confirm.cancel': 'No',

  'global.setting.title': 'Settings',
};
